<!-- eslint-disable vue/multi-word-component-names -->
<!-- no-mutating-props: form/ui/consent are reactive MODEL objects owned by the
     core FormGateBlock; presentational SFCs cannot hold state. -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  questions: {
    id: string;
    title: string;
    answers: [string, string, string?, string?, boolean?][];
  }[];
  gate: {
    title?: string;
    sub_title?: string;
    description?: string;
    namePlaceholder?: string;
    emailPlaceholder?: string;
    nameError?: string;
    emailError?: string;
    usePhone?: boolean;
    useEmail?: boolean;
    cta?: string;
    loading?: string;
    consent_checkbox?: { text: string; required?: boolean };
  };
  quiz: { skip?: boolean; skip_cta?: string };
  form: { name: string; email: string; phone?: string };
  ui: { values: Record<string, string> };
  consent: { checked: boolean };
  fetching: boolean;
}>();
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <form class="tpl-mpf__form" @submit.prevent="$emit('submit')">
    <p v-if="gate.sub_title" class="tpl-mpf__form-banner">{{ gate.sub_title }}</p>

    <template v-for="q in questions" :key="q.id">
      <label class="tpl-mpf__label" :for="'mpf-' + q.id">{{ q.title }} :</label>
      <select
        :id="'mpf-' + q.id"
        class="tpl-mpf__select"
        required
        v-model="ui.values[q.id]"
      >
        <option value="" disabled selected hidden>—</option>
        <option v-for="a in q.answers" :key="a[0]" :value="a[0]">{{ String(a[1]) }}</option>
      </select>
    </template>

    <label class="tpl-mpf__label">{{ gate.namePlaceholder }} :</label>
    <input
      type="text" name="name" class="tpl-mpf__input"
      :placeholder="gate.namePlaceholder" :title="gate.nameError"
      required minlength="3" v-model="form.name"
    />

    <label v-if="gate.useEmail" class="tpl-mpf__label">{{ gate.emailPlaceholder }} :</label>
    <input
      v-if="gate.useEmail" type="email" name="email" class="tpl-mpf__input"
      :placeholder="gate.emailPlaceholder" :title="gate.emailError"
      required pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" v-model="form.email"
    />

    <label v-if="gate.consent_checkbox" class="tpl-mpf__consent">
      <input type="checkbox" name="consent" :required="gate.consent_checkbox.required !== false" v-model="consent.checked" />
      <span>{{ gate.consent_checkbox.text }}</span>
    </label>

    <button type="submit" class="tpl-mpf__cta" :disabled="fetching">
      <span v-if="!fetching">{{ gate.cta }}</span>
      <span v-else>{{ gate.loading || '...' }}</span>
    </button>

    <button
      v-if="quiz.skip && quiz.skip_cta" type="button" class="tpl-mpf__skip"
      :disabled="fetching" @click="$emit('skip')"
    >
      {{ quiz.skip_cta }}
    </button>
  </form>
</template>
